import {
  CircleAlertIcon,
  CircleCheckIcon,
  InfoIcon,
  type LucideIcon,
  XIcon,
} from "lucide-react";
import { ToastItem, ToastType, useToastStore } from "./store";
import S from "./styles.module.scss";

const TOAST_LOOK: Record<ToastType, { icon: LucideIcon; title: string }> = {
  success: { icon: CircleCheckIcon, title: "Tudo certo" },
  error: { icon: CircleAlertIcon, title: "Algo deu errado" },
  info: { icon: InfoIcon, title: "Aviso" },
};

const Toast = ({ toast }: { toast: ToastItem }) => {
  const dismiss = useToastStore((state) => state.dismiss);
  const { icon: Icon, title } = TOAST_LOOK[toast.type];

  return (
    <div
      className={`${S.toast} ${S[toast.type]} ${toast.leaving ? S.leaving : ""}`}
      role={toast.type === "error" ? "alert" : "status"}
    >
      <span className={S.icon} aria-hidden="true">
        <Icon size={18} />
      </span>
      <div className={S.body}>
        <strong className={S.title}>{title}</strong>
        <p className={S.message}>{toast.message}</p>
      </div>
      <button
        type="button"
        className={S.close}
        onClick={() => dismiss(toast.id)}
        aria-label="Fechar aviso"
      >
        <XIcon size={16} />
      </button>
      <span
        className={S.progress}
        style={{ animationDuration: `${toast.duration}ms` }}
        onAnimationEnd={() => dismiss(toast.id)}
        aria-hidden="true"
      />
    </div>
  );
};

const Toaster = () => {
  const toasts = useToastStore((state) => state.toasts);

  return (
    <section className={S.container} aria-label="Avisos">
      {toasts.map((toast) => (
        <Toast key={toast.id} toast={toast} />
      ))}
    </section>
  );
};

export default Toaster;

